var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2764d41faf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 10.460938 L 1005 10.460938 L 1005 1299 L 15 1299 Z M 15 10.460938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2764d41faf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21afbf",
    d: "M 997.949219 399.601562 L 997.949219 399.445312 C 934.21875 7.617188 514.476562 10.929688 510.214844 10.929688 C 509.171875 10.769531 508.113281 10.71875 507.0625 10.773438 C 465.417969 10.773438 83.214844 21.183594 21.855469 399.445312 C 2.191406 529.769531 26.382812 662.933594 90.628906 778.019531 C 199.988281 973.871094 341.753906 1149.769531 509.902344 1298.246094 C 677.960938 1149.730469 819.667969 973.835938 929.015625 778.019531 C 993.378906 663.035156 1017.632812 529.894531 997.949219 399.601562 Z M 509.902344 703.722656 C 465.582031 703.707031 422.265625 690.550781 385.429688 665.917969 C 348.589844 641.285156 319.882812 606.277344 302.9375 565.328125 C 285.992188 524.378906 281.570312 479.324219 290.230469 435.863281 C 298.890625 392.402344 320.246094 352.484375 351.59375 321.15625 C 382.941406 289.832031 422.875 268.503906 466.34375 259.875 C 509.8125 251.242188 554.863281 255.695312 595.800781 272.671875 C 636.738281 289.644531 671.722656 318.375 696.332031 355.234375 C 720.9375 392.089844 734.066406 435.417969 734.046875 479.734375 C 733.945312 539.136719 710.292969 596.074219 668.273438 638.0625 C 626.253906 680.050781 569.300781 703.664062 509.902344 703.722656 Z M 509.902344 703.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGreen);
export default __webpack_public_path__ + "static/media/pin_green.2e465f4679eeef454dc1c5ffa02ee147.svg";
export { ForwardRef as ReactComponent };